import React, { useEffect, useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import axios from 'axios';

const PrintModal = ({ show, onClose, sno }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [purchaseData, setPurchaseData] = useState(null);

  // New state for inputs
  const [subAmount, setSubAmount] = useState('');
  const [discount, setDiscount] = useState('');
  const [gst, setGst] = useState(''); 
  const [totalAmount, setTotalAmount] = useState('');

  useEffect(() => {
    if (sno && show) {
      axios
        .get(`${baseURL}/purchases/${sno}`)
        .then((res) => {
          setPurchaseData(res.data.data);
        })
        .catch((err) => {
          console.error("Failed to fetch purchase details:", err);
        });
    }
  }, [sno, show]);

  // Optional: You can add effect to auto calculate totalAmount based on inputs
  useEffect(() => {
    // parse floats or 0
    const sub = parseFloat(subAmount) || 0;
    const disc = parseFloat(discount) || 0;
    const tax = parseFloat(gst) || 0;

    // calculate total after discount and gst
    const total = (sub - disc) + (tax);
    setTotalAmount(total.toFixed(2));
  }, [subAmount, discount, gst]);

  const handlePrint = () => {
    const printContent = document.getElementById('print-area');

    const WinPrint = window.open('', '', 'width=900,height=650');
    WinPrint.document.write(`
      <html>
        <head>
          <title>Purchase Print</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 30px; }
            h2 { text-align: center; margin-bottom: 20px; }
            .header-section { margin-bottom: 20px; text-align: right; }
            .header-section label { font-weight: 600; display: block; margin-bottom: 2px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            table, th, td { border: 1px solid #ccc; }
            th, td { padding: 8px 12px; text-align: left; }
            .footer-section { margin-top: 30px; text-align: center; font-size: 14px; }
            .summary-table { width: 50%; margin-top: 20px; }
            .summary-table td { padding: 6px 10px; }
            .summary-table input { width: 100%; padding: 4px; }
            @media print {
              .no-print { display: none; }
              body { margin: 0; }
              input { border: none; }
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
          <div class="footer-section">
            <p>--- End of Purchase Details ---</p>
          </div>
        </body>
      </html>
    `);
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  };

  if (!purchaseData) return null;

  return (
    <Modal show={show} size="lg" onHide={onClose}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Purchase List</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>

        <div className="modal-body">
          <div id="print-area">
            <h2 className='text-center'>Purchase Details</h2>

            <div className="header-section">
              <div className='text-end'>
                <label className='text-danger fs-5 font-w600'>{new Date(purchaseData.purchase_date).toLocaleDateString()}</label>
                <label className='text-black fs-6 font-w500 d-block'>{purchaseData.purchase_id}</label>
                <label className='text-black fs-6 font-w500 d-block'>{purchaseData.vendor_no}</label>
                <label className='text-green fs-6 font-w500 d-block'>{purchaseData.vendor_businessname}</label>
                <label className='text-gray-600 fs-8 font-w500 d-block'>{purchaseData.vendor_address}</label>
              </div>
            </div>

            <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
              <thead>
                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                  <th>#</th>
                  <th>Raw Material</th>
                  <th>Brand</th>
                  <th>Quantity</th>
                  <th>Unit</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {purchaseData.raw_material.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.rawmaterial_name}</td>
                    <td>{item.brand || '—'}</td>
                    <td>{item.quantity}</td>
                    <td>{item.unitslug_name}</td>
                    <td>{item.amount || ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
 

          </div>

          {/* Scroll only in modal, not in print */}
          {purchaseData.raw_material.length > 10 && (
            <style>
              {`
                .modal-body {
                  max-height: 450px;
                  overflow-y: auto;
                }
              `}
            </style>
          )}

          <div className="d-flex align-items-center justify-content-center gap-3 mt-4 no-print">
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button variant="primary" onClick={handlePrint}>Print</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PrintModal;
